import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import AuthShell from "../components/Auth/AuthShell";
import api from "../services/api";
import { PATHS } from "../routes/paths";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [showRecoveryLink, setShowRecoveryLink] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const passwordRules = [
    { label: "Pelo menos 8 caracteres", test: (v) => v.length >= 8 },
    { label: "Pelo menos 1 letra maiúscula", test: (v) => /[A-Z]/.test(v) },
    { label: "Pelo menos 1 letra minúscula", test: (v) => /[a-z]/.test(v) },
    { label: "Pelo menos 1 número", test: (v) => /[0-9]/.test(v) },
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    setShowRecoveryLink(false);

    if (!token) {
      setError("Link de recuperacao invalido ou expirado.");
      setShowRecoveryLink(true);
      return;
    }

    if (password !== confirmPassword) {
      setError("As senhas nao conferem.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await api.post("/auth/reset-password", {
        token,
        password,
        confirmPassword,
      });
      setMessage("success");
      setPassword("");
      setConfirmPassword("");
      setTimeout(() => navigate(PATHS.login), 5000);
    } catch (requestError) {
      setError(requestError.response?.data?.error || "Nao foi possivel redefinir a senha.");
      setShowRecoveryLink(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell title="Redefinição de senha">
      <form className="auth-form auth-form--compact" onSubmit={handleSubmit}>
        <label className="auth-form__field">
          <span className="auth-form__label">Nova senha</span>
          <input
            className="auth-form__input"
            type="password"
            placeholder="Nova senha"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
            required
          />
          {password.length > 0 && (
            <ul className="password-rules">
              {passwordRules.map((rule) => {
                const met = rule.test(password);
                return (
                  <li
                    key={rule.label}
                    className={`password-rules__item ${met ? "password-rules__item--valid" : ""}`}
                  >
                    <span className="password-rules__icon" aria-hidden="true">
                      {met ? "✓" : "○"}
                    </span>
                    <span>{rule.label}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </label>

        <label className="auth-form__field">
          <span className="auth-form__label">Confirmar nova senha</span>
          <input
            className="auth-form__input"
            type="password"
            placeholder="Confirmar nova senha"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        {message === "success" && (
          <div className="auth-form__message auth-form__message--success">
            <p>Senha redefinida com sucesso!</p>
            <p>Redirecionando para o login...</p>
          </div>
        )}
        {message && message !== "success" && <p className="auth-form__message auth-form__message--success">{message}</p>}
        {error && <p className="auth-form__message auth-form__message--error">{error}</p>}
        {showRecoveryLink && (
          <Link className="auth-form__footer-link" to={PATHS.forgotPassword}>
            Solicitar nova recuperacao
          </Link>
        )}

        <button
          className="auth-form__button auth-form__button--compact"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Confirmando..." : "Confirmar"}
        </button>
      </form>
    </AuthShell>
  );
};

export default ResetPassword;
